import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Email(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.contactInformation.email.label}>
      {extOrder.orderStep.email ?? <preview.NullValue />}
    </preview.Field>
  )
}
